import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=a9de297a&scoped=true"
var script = {}
import style0 from "./Help.vue?vue&type=style&index=0&id=a9de297a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9de297a",
  null
  
)

export default component.exports